import { useState, useEffect } from 'react'
import config from 'config'
import { NetworkBasicInfo, Graph2Network } from './types'

interface SSONetworksHook {
  loading: boolean
  networks: NetworkBasicInfo[]
  selectedNetwork: NetworkBasicInfo | undefined
  setSelectedNetwork: (network: NetworkBasicInfo | undefined) => void
}

export const useSSONetworks = (): SSONetworksHook => {
  const [loading, setLoading] = useState(true)
  const [networks, setNetworks] = useState<NetworkBasicInfo[]>([])
  const [selectedNetwork, setSelectedNetwork] = useState<NetworkBasicInfo>()

  useEffect(() => {
    fetch(`${config.NEXT_PUBLIC_API_URL}/auth/saml/sso-networks`)
      .then(res => res.json())
      .then(data => {
        setNetworks(
          data.map((network: Graph2Network) => ({
            id: network[':network/name'],
            name: network[':network/name'],
            title: network[':network/title']
          }))
        )
        setLoading(false)
      })
    setLoading(false)
  }, [])

  return { loading, networks, selectedNetwork, setSelectedNetwork }
}
